import React from 'react';
import { styled } from 'linaria/react';
import { DrawerTrigger } from '@jetshop/ui/Modal/Drawer/DrawerTrigger';
import { useProductList } from '@jetshop/core/hooks/ProductList';
import { theme } from '../Theme';

import { ReactComponent as Heart } from '../../svg/fa/heart_new.svg';
import { useIntl } from '@jetshop/intl';

const Container = styled('button')`
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 0 4px !important; */
  position: relative;
  width: 50px;
  height: 100%;
`;

const Count = styled('div')`
  align-items: center;
  background: ${theme.colors.primary};
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 10px;
  font-weight: bold;
  height: 19px;
  justify-content: center;
  line-height: 1;
  right: -12px;
  position: absolute;
  top: -8px;
  width: 19px;
`;

export function FavouriteCount() {
  const { count } = useProductList();
  const translate = useIntl();
  const ariaLabel = translate('Favourite products');

  return (
    <DrawerTrigger id="favourites-drawer">
      {drawer => (
        <Container
          aria-label={ariaLabel}
          onClick={drawer.isOpen ? drawer.hideTarget : drawer.showTarget}
        >
          <div style={{ position: 'relative' }}>
            <Heart />
            {count > 0 && <Count>{count}</Count>}
          </div>
        </Container>
      )}
    </DrawerTrigger>
  );
}
